export default __webpack_public_path__ + "static/media/Intro4.cf32b37f.mp3";